"use client";

import React from "react";
import { Badge } from "@/components/ui/badge";
import { Label } from "@/components/ui/label";
import { useTranslation } from "react-i18next";

type GenderValue = "male" | "female" | "";

interface GenderBadgesProps {
  value: GenderValue;
  onChange: (value: Exclude<GenderValue, "">) => void;
}

const GenderBadges: React.FC<GenderBadgesProps> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-2">
      <Label htmlFor="gender">{t("parent-info-pet-parent-title-header")}</Label>
      <div className="flex items-center gap-2">
        <Badge
          id="gender-male"
          variant={value === "male" ? "default" : "outline"}
          className="cursor-pointer px-3 py-1"
          onClick={() => onChange("male")}
        >
          {t("contactDetails.genderMale", { defaultValue: "Männlich" })}
        </Badge>
        <Badge
          id="gender-female"
          variant={value === "female" ? "default" : "outline"}
          className="cursor-pointer px-3 py-1"
          onClick={() => onChange("female")}
        >
          {t("contactDetails.genderFemale", { defaultValue: "Weiblich" })}
        </Badge>
      </div>
    </div>
  );
};

export default GenderBadges;
